import { useMutation, useQueryClient } from '@tanstack/react-query'
import type {
  CreateProviderInput,
  CreateServiceInput,
  MeProviderResponse,
  ProviderDetailResponse,
  ServiceDetailResponse,
} from 'shared'
import { apiPost } from '../lib/api'
import { providerMeKey } from './useProviderProfile'

export function useCreateProvider() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (input: CreateProviderInput) =>
      apiPost<ProviderDetailResponse>('/providers', input),
    // seed the profile cache so the post-onboarding guards see it immediately
    onSuccess: ({ provider }) => {
      qc.setQueryData<MeProviderResponse>(providerMeKey, { provider })
    },
  })
}

export function useCreateService() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (input: CreateServiceInput) =>
      apiPost<ServiceDetailResponse>('/services', input),
    onSuccess: () => {
      // profile carries the provider's services; the public list changes too
      qc.invalidateQueries({ queryKey: providerMeKey })
      qc.invalidateQueries({ queryKey: ['services'] })
    },
  })
}
